import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import '../styles/PaymentModal.css';
import { initiateNOWPaymentsPayment } from '../services/nowPaymentsService';

const PaymentModal = ({ isOpen, onClose, onSuccess }) => {
  const [paymentMethod, setPaymentMethod] = useState('hotmart');
  const [isLoading, setIsLoading] = useState(false);

  const handleHotmartClick = (e) => {
    e.preventDefault();
    // Abre el link en nueva pestaña sin redirigir
    window.open('https://pay.hotmart.com/T103345810R', '_blank');
  };

  const handleNOWPayments = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await initiateNOWPaymentsPayment();
    } catch (error) {
      console.error('Payment error:', error);
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <motion.div
        className="modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      />

      <motion.div
        className="payment-modal"
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: 20 }}
        transition={{ duration: 0.3 }}
      >
        <button className="close-button" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="modal-content">
          <h2>Asegura tu acceso ahora</h2>
          <p className="modal-subtitle">Únete a los primeros 100 operadores con acceso a todos los bonos</p>

          <div className="payment-method-tabs">
            <button
              className={`tab ${paymentMethod === 'hotmart' ? 'active' : ''}`}
              onClick={() => setPaymentMethod('hotmart')}
              type="button"
            >
              💳 Débito/Crédito
            </button>
            <button
              className={`tab ${paymentMethod === 'nowpayments' ? 'active' : ''}`}
              onClick={() => setPaymentMethod('nowpayments')}
              type="button"
            >
              ₿ Criptomonedas
            </button>
          </div>

          <div className="modal-summary">
            <div className="summary-item">
              <span>Entrenamiento Intensivo EMI</span>
              <strong>$99 USD</strong>
            </div>
            <div className="summary-divider"></div>
            <div className="summary-item total">
              <span>Total a pagar:</span>
              <strong className="total-amount">$99 USD</strong>
            </div>
          </div>

          {paymentMethod === 'hotmart' ? (
            <form onSubmit={handleHotmartClick} className="payment-form">
              <motion.button
                type="submit"
                className="payment-button"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                disabled={isLoading}
              >
                💳 Pagar con tarjeta débito/crédito
              </motion.button>
            </form>
          ) : (
            <form onSubmit={handleNOWPayments} className="payment-form">
              <motion.button
                type="submit"
                className="payment-button"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                disabled={isLoading}
              >
                {isLoading ? '⏳ Generando enlace de pago...' : '₿ Pagar con Criptomonedas - $99'}
              </motion.button>
            </form>
          )}

          <div className="modal-security">
            <strong>🔒 Pago 100% Seguro</strong>
            <p>Tu información está protegida con encriptación de nivel bancario</p>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default PaymentModal;
